namespace Solovis.UI.Icons {

    export function createEntityIcon(cssRules?) {
        var iconSpan = $("<span>").addClass("fa fa-circle");

        if (cssRules) {
            iconSpan.css(cssRules);
        }

        return iconSpan;
    }

    export function createTagIcon(cssRules?) {
        var iconSpan = $("<span>").addClass("fa fa-tag");

        if (cssRules) {
            iconSpan.css(cssRules);
        }

        return iconSpan;
    }

    export function createInvestmentIcon(cssRules?) {
        var iconDiv = $("<div>")
            .css({
                "display": "inline-block",
                "position": "relative"
            });

        $("<span>")
            .addClass("fa fa-circle")
            .css({
                "position": "relative",
                "top": "-2px",
                "left": "2px",
                "font-size": "7px"
            })
            .appendTo(iconDiv);

        $("<span>")
            .addClass("fa fa-minus")
            .css({
                "font-size": "7px",
                "position": "relative",
                "top": "-2px"
            })
            .appendTo(iconDiv);

        $("<span>")
            .addClass("fa fa-circle")
            .css({
                "position": "relative",
                "top": "-2px",
                "left": "-2px",
                "font-size": "7px"
            })
            .appendTo(iconDiv);

        if (cssRules) {
            iconDiv.css(cssRules);
        }

        return iconDiv;
    }

    export function createContactIcon(cssRules?) {
        var iconSpan = $("<span>").addClass("fa fa-group");

        if (cssRules) {
            iconSpan.css(cssRules);
        }

        return iconSpan;
    }

    export function createReportIcon(cssRules?) {
        var iconSpan = $("<span>").addClass("fa fa-bar-chart");

        if (cssRules) {
            iconSpan.css(cssRules);
        }

        return iconSpan;
    }

    export function createUserIcon(cssRules?) {
        var iconSpan = $("<span>").addClass("fa fa-user");

        if (cssRules) {
            iconSpan.css(cssRules);
        }

        return iconSpan;
    }

    export function createMoreResultsIcon(cssRules?) {
        var iconSpan = $("<span>").addClass("fa fa-search");

        if (cssRules) {
            iconSpan.css(cssRules);
        }

        return iconSpan;
    }

    export function createTagsIcon(cssRules?) {
        var iconSpan = $("<span>").addClass("glyphicon glyphicon-tags");

        if (cssRules) {
            iconSpan.css(cssRules);
        }

        return iconSpan;
    }
}